// extracted by mini-css-extract-plugin
module.exports = {"ArticleImageText":"styles_ArticleImageText__176Dm","reversed":"styles_reversed__38ZpI","texts":"styles_texts__1USoG","image":"styles_image__1RhN6","text":"styles_text__a9JO0"};